import React from "react";

import { SocketContextProvider } from "../common/context/quoteFormConnector";
import { LandingContext } from "../products/context/landing";
import { DynamicQuoteForm } from "./components/Form";
import { Container } from "./components/Form/Container";
import { Head } from "./components/Head";
import { RequoteForm } from "./components/RequoteForm";
import { DynamicQuoteSummary } from "./components/Summary";
import { QuoteFormStateProvider } from "./state";

const Quote: React.FC = () => {
  const { offersMode } = React.useContext(LandingContext);

  return (
    <>
      <Head />
      <SocketContextProvider>
        <QuoteFormStateProvider>
          <RequoteForm>
            {offersMode ? (
              <DynamicQuoteSummary />
            ) : (
              <Container>
                <DynamicQuoteForm />
              </Container>
            )}
          </RequoteForm>
        </QuoteFormStateProvider>
      </SocketContextProvider>
    </>
  );
};

export { Quote };
